import {EventItem} from "./event-item";

export enum DiscountType {
  COUPON = 1,
  FREQUENT_COMPETITOR_DISCOUNT =2,
  GROUP_REGISTRATION_DISCOUNT=3,
  SERIES_REGISTRATION_DISCOUNT=4
}

export enum DiscountCoversType {
  REGISTRATION_FEE = 1,
  ALL_CHARGES = 2
}

export class Discount {
  id?: number;
  organiserId?: number;
  discountType?:DiscountType;
  discountCode?:string;
  name?:string;
  description?:string;
  // list of events/races that this coupon is applied
  events?:EventItem[];
  // discount is valid from
  dateFrom?:Date;
  // dicsount if valid until
  dateTo?:Date;
  // is the discount applied as percentage or absolute amount
  applicationOfDiscountWithPercentage?:boolean;
  // amount as absolute number or percentage
  amount?:number;
  // is the amount of discount different for different number of races, applied only for
  // - Frequent competitor
  // - Series registration discount
  discountOnMoreRaces?:boolean;
  // list of items with number of races and amount applied on that number of races
  discountOnMoreRacesItems?:DiscountItem[];
  discountCovers?: DiscountCoversType;
  // do we have usage limit for a specific coupon
  usageLimit?:boolean;
  // if we have a usage limit how much it is, for example 10 means that this coupon can only be used 10 times
  usageMaxAllowed?:number;
  // is it allows to combine this discount with other discounts
  standaloneUsageOfDiscount?:boolean;
  // is the discount active
  active?:boolean;
}

export class DiscountItem {
  numberOfRaces?:number;
  // is the discount applied as percentage or absolute amount
  amount?:number;


  constructor(numberOfRaces: number, amount: number) {
    this.numberOfRaces = numberOfRaces;
    this.amount = amount;
  }
}
